export const DEPENDENTS_VALIDATION_RULES = {
  firstName: {
    isRequiredTrim: {
      value: true,
    },
  },
  lastName: {
    isRequiredTrim: {
      value: true,
    },
  },
  relationshipType: {
    isRequiredTrim: {
      value: true,
    },
  },
  genderType: {
    isRequiredTrim: {
      value: true,
    },
  },
  birthdate: {
    isRequiredTrim: {
      value: true,
    },
  },
  disabilityStartDate: {
    isRequiredTrimIfField: {
      value: {
        field: "isDisabled",
      },
    },
    afterOrEqualOtherDateField: {
      value: {
        field: "birthdate",
        customMessageKey: "validation.customMessages.birthdate",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/dependentsValidationRules.js